































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "record-guide-component",
})
export default class RecordGuideComponent extends Vue {
  @Prop({ type: Boolean, default: false }) active;

  @Emit()
  closeRecordGuide() {
    localStorage.setItem("record_guide", "true");
  }
}
